// Opens the Smile.io loyalty panel from any [data-smile-trigger] button.
//
// Delegated on the document so it works for multiple buttons, buttons added
// later (theme editor), and regardless of when Smile's SDK (window.SmileUI)
// finishes loading.
document.addEventListener('click', (event) => {
  const trigger = event.target instanceof Element ? event.target.closest('[data-smile-trigger]') : null;
  if (!trigger) return;

  event.preventDefault();

  if (window.SmileUI && typeof window.SmileUI.openPanel === 'function') {
    window.SmileUI.openPanel();
  }
});
